import { Component, EventEmitter, Input, OnChanges, OnInit, Output, QueryList, SimpleChanges, ViewChildren } from '@angular/core';
import { CompaniesService } from '../list-companies.service';
import { TypeBill } from 'src/app/core/interfaces/typeBill';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { NgxSpinnerService } from 'ngx-spinner';
import { Utils } from 'src/app/core/resources/utils';
import { ServiceMessages } from 'src/app/core/messages/service-messages.enum';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { Fmt } from 'src/app/core/messages/fmt';
import { BasicBillType } from 'src/app/core/interfaces/billingConfiguration';
import { AdditionalCost } from 'src/app/core/interfaces/additionalCost';
import { forkJoin, Observable, of, Subscription } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { CityService } from '../../city/city.service';
import { ApiResponseSiigo, ProductSiigo } from 'src/app/core/interfaces/productSiigo';
import { OnboardingTourService } from 'src/app/core/services/onboarding-tour.service';
import { DriveStep } from 'driver.js';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { OpenImgComponent } from 'src/app/shared/open-img/open-img.component';
import { FormControl, Validators } from '@angular/forms';
import { OptionsAutocomplete } from 'src/app/core/interfaces/optionsAutocomplete';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/core/services/authentication.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { CatalogService } from 'src/app/core/services/catalog.service';
import { Catalog } from 'src/app/core/interfaces/catalog';
import { CatalogItem } from 'src/app/core/interfaces/catalogItem';
import { PreBillField, PreBillFieldView } from 'src/app/core/interfaces/preBillField';
import { ApiResponse } from 'src/app/core/interfaces/apiResponse';
@Component({
  selector: 'app-administrative-configuration',
  templateUrl: './administrative-configuration.component.html',
  styleUrls: ['./administrative-configuration.component.scss']
})
export class AdministrativeConfigurationComponent implements OnInit, OnChanges {

  @ViewChildren('selectList') selectList!: QueryList<MatSelect>;

  // Inputs
  @Input() typeBill: BasicBillType = { code: '', description: '' };
  @Input() expirationDays: number;
  @Input() requiresPreInvoice: boolean = false;
  @Input() nitCompany: string = '';
  // Outputs
  @Output() clickedTab: EventEmitter<string> = new EventEmitter();
  @Output() refreshList: EventEmitter<boolean> = new EventEmitter();
  // Properties
  listTypeBill: BasicBillType[] = [];
  listAdditionalServices: AdditionalCost[] = [];
  listProductSiigo: ProductSiigo[] = [];
  pageKey: number = 1;
  pageSize: number = 50;
  messageListTypeBill: string = '';
  messageListAdditionalServices: string = '';
  messageListProductSiigo: string = '';
  selectedTypeBill: BasicBillType;
  selectedProductSiigo: string = '';
  listAdditionalServicesControls: string[] = [];
  isLoadingProducts: boolean = false;
  currentIndexLoading: number | null = null;
  cityControl: FormControl = new FormControl();
  optionsCity: OptionsAutocomplete = {
    title: 'Buscar ciudad',
    requireFullCity: true,
    showBillingInfo: true
  };
  citySub: Subscription;
  attemps: number = 0;
  incomeConsecutiveControl: FormControl = new FormControl(0, [Validators.required, Validators.min(1)]);
  expenseConsecutiveControl: FormControl = new FormControl(0, [Validators.required, Validators.min(1)]);
  receiptFintechConsecutiveControl: FormControl = new FormControl(0, [Validators.required, Validators.min(1)]);
  maxExpirationDays: number = 120;
  expirationDaysControl: FormControl = new FormControl(null, [Validators.min(0), Validators.max(this.maxExpirationDays)]);
  requiresPreInvoiceControl: FormControl = new FormControl(false);
  preBillFieldToAddControl: FormControl = new FormControl(null);
  preBillOptions: PreBillFieldView[] = [];
  preBillCatalog: CatalogItem[] = [];
  savedPreBillFields: PreBillField[] = [];
  loadingPreBillFields: boolean = false;
  constructor(
    private companiesService: CompaniesService,
    private authService: AuthService,
    private spinner: NgxSpinnerService,
    public utils: Utils,
    private snackBarService: SnackBarService,
    private cityService: CityService,
    private onboardingTourService: OnboardingTourService,
    private matDialog: MatDialog,
    private router: Router,
    private catalogService: CatalogService
  ) { }

  ngOnInit() {
    this.clickedTab.emit("Configuración administrativa");
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.expirationDays && this.utils.isDefined(this.expirationDays))
      this.expirationDaysControl.setValue(this.expirationDays);
    if (changes.requiresPreInvoice && this.utils.isDefined(this.requiresPreInvoice))
      this.requiresPreInvoiceControl.setValue(this.requiresPreInvoice);
    if (this.requiresPreInvoiceControl.value && this.nitCompany && (changes.requiresPreInvoice || changes.nitCompany))
      this.loadPreBillFields();
  }

  startTour(): void {
    const steps: DriveStep[] = [
      {
        element: '#billingExpirationStep',
        popover: {
          title: 'Días acordados para el pago de facturas',
          description: 'Este plazo de pago define el tiempo máximo de pago acordado por contrato para cada servicio.',
          side: 'bottom'
        },
        disableActiveInteraction: true,
      },
      {
        element: '#preInvoiceStep',
        popover: {
          title: 'Prefactura',
          description: 'Indica si la empresa requiere visualizar un resumen de los valores a facturar antes de generar la factura real.',
          side: 'bottom'
        },
        disableActiveInteraction: true,
      },
    ];
    if (!this.onboardingTourService.driverInstance) this.onboardingTourService.setDriverInstanceConfig();
    this.onboardingTourService.setSteps(steps);
    this.onboardingTourService.startTour();
  }

  private async getConsecutives() {
    try {
      const receiptResponse = await this.companiesService.getConsecutive('Receipt').toPromise();
      const journalResponse = await this.companiesService.getConsecutive('Journal').toPromise();
      this.incomeConsecutiveControl.setValue(journalResponse ? journalResponse : 0);
      this.expenseConsecutiveControl.setValue(receiptResponse ? receiptResponse : 0);
    } catch (error) {
      this.snackBarService.openSnackBar(Fmt.string(ServiceMessages.ERROR_GETTING_DATA, 'los consecutivos'), undefined, 'error');
    }
    if (this.isTeclogiUser) {
      try {
        const receiptFintechResponse = await this.companiesService.getConsecutive('ReceiptFintech').toPromise();
        this.receiptFintechConsecutiveControl.setValue(receiptFintechResponse ? receiptFintechResponse : 0);
      } catch (error) {
        this.snackBarService.openSnackBar(Fmt.string(ServiceMessages.ERROR_GETTING_DATA, 'el consecutivo de recibos de LoggiCash'), undefined, 'error');
      }
    }
  }

  getServices() {
    this.spinner.show();
    this.messageListTypeBill = '';
    this.messageListAdditionalServices = '';
    this.messageListProductSiigo = '';
    const services$: [Observable<ApiResponse<TypeBill>>, Observable<ApiResponse<AdditionalCost>>] = [
      this.getListTypeBill(),
      this.getListAdditionalServices()
    ]
    forkJoin(services$).pipe(finalize(() => {
      this.spinner.hide();
      this.checkIfInfoEmpty();
    })).subscribe({
      next: ([typeBillResponse, additionalServicesResponse]) => {
        this.processTypeBillResponse(typeBillResponse);
        this.processAdditionalServicesResponse(additionalServicesResponse);
      }
    });
  }

  checkIfInfoEmpty() {
    const typeBillEmpty = this.typeBill && (!this.typeBill.code || !this.typeBill.description);
    const additionalServicesEmpty = !this.listAdditionalServices.length || (this.listAdditionalServices.length && this.listProductSiigo.length && !this.listAdditionalServices.every(additionalService => !!additionalService.productSiigoId));
    if (typeBillEmpty && additionalServicesEmpty) this.startTour();
    if (this.listAdditionalServices.length) this.getProductSiigo();
  }

  processTypeBillResponse(typeBillResponse: ApiResponse<TypeBill>): void {
    if (!typeBillResponse || typeBillResponse.error) this.messageListTypeBill = Fmt.string(ServiceMessages.ERROR_GETTING_DATA, 'los tipos de documentos');
    else if (!typeBillResponse.data || typeBillResponse.data.length === 0) this.messageListTypeBill = Fmt.string(ServiceMessages.NO_DATA_FOUND, 'tipos de documento de factura');
    else this.listTypeBill = typeBillResponse.data;
  }

  processAdditionalServicesResponse(additionalServicesResponse: ApiResponse<AdditionalCost>): void {
    if (!additionalServicesResponse || additionalServicesResponse.error) this.messageListAdditionalServices = Fmt.string(ServiceMessages.ERROR_GETTING_DATA, 'los servicios adicionales');
    else if (!additionalServicesResponse.data || additionalServicesResponse.data.length === 0) this.messageListAdditionalServices = Fmt.string(ServiceMessages.NO_DATA_FOUND, 'servicios adicionales');
    else this.listAdditionalServices = additionalServicesResponse.data;
  }

  processProductSiigoResponse(productSiigoResponse: ApiResponse<ProductSiigo>, totalResults?: number): void {
    if (!productSiigoResponse || productSiigoResponse.error) this.messageListProductSiigo = Fmt.string(ServiceMessages.ERROR_GETTING_DATA, 'los productos siigo');
    else if (!productSiigoResponse.data || productSiigoResponse.data.length === 0) this.messageListProductSiigo = Fmt.string(ServiceMessages.NO_DATA_FOUND, 'productos siigo');
    else {
      if (this.pageKey && this.pageKey == 1) this.listProductSiigo = productSiigoResponse.data;
      else this.listProductSiigo = [...this.listProductSiigo, ...productSiigoResponse.data];
      if (totalResults && this.listProductSiigo.length < totalResults && this.attemps < 10) {
        this.pageKey++;
        this.attemps++;
        this.getProductSiigo();
      } else this.attemps = 0;
    };
  }

  getListTypeBill(): Observable<ApiResponse<TypeBill>> {
    return this.companiesService.listTypeBill().pipe(
      map((data: TypeBill[]) => ({ data, error: '' })),
      catchError((error): Observable<ApiResponse<TypeBill>> => {
        return of({ data: [], error: error });
      })
    );
  }

  getListAdditionalServices(): Observable<ApiResponse<AdditionalCost>> {
    return this.companiesService.getAdditionalServices().pipe(
      map((data: AdditionalCost[]) => ({ data, error: '' })),
      catchError((error): Observable<ApiResponse<AdditionalCost>> => {
        return of({ data: [], error: error });
      })
    );
  }

  onProductSiigoChange(event: MatSelectChange, index: number) {
    const productSiigoId = event.value;
    this.updateProductSiigoAdditionalService(productSiigoId, this.listAdditionalServices[index]);
  }

  public getProductSiigo() {
    this.isLoadingProducts = true;
    const listProductSiigoObserver = {
      next: (data: ApiResponseSiigo) => {
        const totalResults = this.utils.getNestedValue(data, 'pagination.totalResults');
        this.processProductSiigoResponse({ data: data.results, error: '' }, totalResults);
      },
      error: (error) => {
        this.processProductSiigoResponse({ data: [], error: error });
      }
    }
    this.cityService.getProductSiigo(this.pageKey, this.pageSize).pipe(finalize(() => {
      this.isLoadingProducts = false;
    })).subscribe(listProductSiigoObserver);
  }

  onSelectTypeBill(event: MatSelectChange) {
    let code = this.utils.getNestedValue(event.value, 'id');
    let description = this.utils.getNestedValue(event.value, 'description');
    if (code && description) this.updateTypeBillCompany({ code, description });
    else this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
  }

  updateTypeBillCompany(typeBill: BasicBillType) {
    const updateTypeBillCompanyObserver = {
      next: (response: { message: string }) => {
        if (response && response.message) {
          this.snackBarService.openSnackBar(Fmt.string(ServiceMessages.FIELD_UPDATED_SUCCESSFULLY, 'el tipo de documento de factura'), undefined, 'success');
          this.refreshList.emit(true);
        } else this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
      },
      error: () => {
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
      }
    }
    this.spinner.show();
    this.companiesService.updateTypeBillCompany({
      documentTypeId: { code: typeBill.code, description: typeBill.description },
      expirationDays: this.expirationDaysControl.value,
      requiresPreInvoice: !!this.requiresPreInvoiceControl.value
    }, this.nitCompany).pipe(finalize(() => this.spinner.hide())).subscribe(updateTypeBillCompanyObserver);
  }

  updateExpirationDays() {
    if (this.utils.errorMessagesCustomized(this.expirationDaysControl, 'días para pago de facturas', null, null, 0, this.maxExpirationDays)) return;
    this.saveBillingConfiguration();
  }

  onRequiresPreInvoiceChange() {
    this.saveBillingConfiguration();
    if (this.requiresPreInvoiceControl.value)
      this.loadPreBillFields();
  }

  saveBillingConfiguration() {
    const body = {
      expirationDays: this.expirationDaysControl.value,
      requiresPreInvoice: !!this.requiresPreInvoiceControl.value
    }
    if (this.typeBill && this.isPrincipalCompany)
      body['documentTypeId'] = { code: this.typeBill.code, description: this.typeBill.description };
    this.spinner.show();
    this.companiesService.updateTypeBillCompany(body, this.nitCompany).pipe(finalize(() => this.spinner.hide())).subscribe({
      next: (response: { message: string }) => {
        this.snackBarService.openSnackBar(Fmt.string(ServiceMessages.FIELD_UPDATED_SUCCESSFULLY, 'la configuración de facturación'), undefined, 'success');
        this.refreshList.emit(true);
      },
      error: () => {
        this.snackBarService.openSnackBar(Fmt.string(ServiceMessages.ERROR_UPDATING_DATA, 'la configuración de facturación'), undefined, 'error');
      }
    });
  }

  private async loadPreBillFields() {
    if (!this.nitCompany || this.loadingPreBillFields) return;
    this.loadingPreBillFields = true;
    if (!this.preBillCatalog.length) this.preBillCatalog = await this.getPreBillCatalog();
    this.savedPreBillFields = await this.getSavedPreBillFields();
    this.loadingPreBillFields = false;
    this.mergePreBillFields();
  }

  private async getPreBillCatalog(): Promise<CatalogItem[]> {
    try {
      const items = await this.catalogService.getCargoQueryableVariables().toPromise();
      return items || [];
    } catch (error) {
      return [];
    }
  }

  private async getSavedPreBillFields(): Promise<PreBillField[]> {
    try {
      const savedFields = await this.companiesService.getPreBillFields(this.nitCompany).toPromise();
      return savedFields && Array.isArray(savedFields) ? savedFields.filter(field => field && field.id) : [];
    } catch (error) {
      return [];
    }
  }

  private mergePreBillFields(): void {
    const catalogById: { [id: string]: CatalogItem } = {};
    this.preBillCatalog.forEach(item => {
      if (item && item.id) catalogById[item.id] = item;
    });
    this.preBillOptions = this.savedPreBillFields.filter(field => field && field.id).map(field => {
      const catalogItem = catalogById[field.id];
      return {
        id: field.id,
        name: (catalogItem && catalogItem.name) || field.name || '',
        description: catalogItem && catalogItem.description ? catalogItem.description : '',
        order: field.order || 0,
        alias: field.alias || ''
      };
    });
    this.sortPreBillOptions();
  }

  get availablePreBillCatalogItems(): CatalogItem[] {
    const selectedIds = this.preBillOptions.map(option => option.id);
    return this.preBillCatalog.filter(item => item && item.id && selectedIds.indexOf(item.id) === -1);
  }

  get preBillEmptyMessage(): string {
    if (this.loadingPreBillFields) return 'Cargando campos...';
    if (!this.preBillCatalog.length) return 'No hay campos disponibles para configurar.';
    return 'No hay campos agregados. Seleccione un campo del catálogo para incluirlo en la prefactura.';
  }

  addPreBillField(event: MatSelectChange) {
    const selectedId = event && event.value;
    const catalogItem = this.preBillCatalog.find(item => item && item.id === selectedId);
    this.preBillFieldToAddControl.setValue(null, { emitEvent: false });
    if (!catalogItem || this.preBillOptions.some(option => option.id === catalogItem.id)) return;
    this.preBillOptions.push({
      id: catalogItem.id,
      name: catalogItem.name || '',
      description: catalogItem.description || '',
      order: this.preBillOptions.length + 1,
      alias: ''
    });
  }

  dropPreBillField(event: CdkDragDrop<PreBillFieldView[]>) {
    moveItemInArray(this.preBillOptions, event.previousIndex, event.currentIndex);
    this.reindexPreBillOptions();
  }

  private sortPreBillOptions() {
    this.preBillOptions.sort((a, b) => (a.order || 0) - (b.order || 0));
    this.reindexPreBillOptions();
  }

  private reindexPreBillOptions() {
    this.preBillOptions.forEach((option, index) => option.order = index + 1);
  }

  savePreBillFields() {
    if (!this.nitCompany) return;
    const selected: PreBillField[] = this.preBillOptions.map((option, index) => {
      const payload: PreBillField = {
        id: option.id,
        name: option.name,
        order: index + 1
      };
      const alias = option.alias && option.alias.trim();
      if (alias) payload.alias = alias;
      return payload;
    });
    if (!selected.length)
      return this.snackBarService.openSnackBar("Debe seleccionar al menos un campo para guardar la configuración de prefactura", undefined, 'alert');
    this.spinner.show();
    this.companiesService.savePreBillFields(this.nitCompany, selected).pipe(finalize(() => this.spinner.hide())).subscribe({
      next: () => {
        this.savedPreBillFields = selected;
        this.snackBarService.openSnackBar(Fmt.string(ServiceMessages.FIELD_UPDATED_SUCCESSFULLY, 'la configuración de prefactura'), undefined, 'success');
      },
      error: () => {
        this.snackBarService.openSnackBar(Fmt.string(ServiceMessages.ERROR_UPDATING_DATA, 'la configuración de prefactura'), undefined, 'error');
      }
    });
  }

  async removePreBillField(option: PreBillFieldView) {
    if (!option || !option.id) return;
    const savedOption = this.savedPreBillFields.find(field => field.id === option.id);
    if (savedOption) {
      this.spinner.show();
      try {
        await this.companiesService.deletePreBillField(this.nitCompany, savedOption.id).toPromise();
        this.savedPreBillFields = this.savedPreBillFields.filter(field => field.id !== option.id);
        this.preBillOptions = this.preBillOptions.filter(item => item.id !== option.id);
        this.reindexPreBillOptions();
        this.snackBarService.openSnackBar(Fmt.string(ServiceMessages.FIELD_DELETED_SUCCESSFULLY, 'el campo de prefactura'), undefined, 'success');
      } catch (error) {
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
      }
      this.spinner.hide();
      return;
    }
    this.preBillOptions = this.preBillOptions.filter(item => item.id !== option.id);
    this.reindexPreBillOptions();
  }

  updateProductSiigoAdditionalService(productSiigoId: string, additionalService: AdditionalCost) {
    const updateProductSiigoAdditionalServiceObserver = {
      next: (response: { message: string }) => {
        if (response && response.message) {
          this.snackBarService.openSnackBar(`${Fmt.string(ServiceMessages.FIELD_UPDATED_SUCCESSFULLY, 'el producto siigo')} del servicio adicional ${additionalService.name}`, undefined, 'success');
        }
      },
      error: () => {
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
      }
    }
    this.spinner.show();
    this.companiesService.updateProductSiigoAdditionalService(productSiigoId, additionalService.id).pipe(finalize(() => this.spinner.hide())).subscribe(updateProductSiigoAdditionalServiceObserver);
  }

  // Compara cada uno de los elementos de la lista con el valor seteado en el select donde option1 va a ser cada uno de los elementos de la lista y option2 va a ser el valor seteado en el select
  compareTypeBill = (option1: TypeBill, option2: BasicBillType): boolean => {
    if (!option1 || !option2 || !this.utils.isDefined(option1.id) || !option2.code) return false;
    return option1.id.toString() === option2.code && option1.description === option2.description;
  }

  compareProductSiigo = (option1: string, option2: string): boolean => {
    if (!option1 || !option2) return false;
    return option1 === option2;
  }

  openModalCargoPDF(url: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: 'Habilitar factura tipo 12 en Siigo',
      src: url,
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.matDialog.open(OpenImgComponent, dialogConfig);
  }

  setSubscriptionCity() {
    this.citySub = this.cityControl.valueChanges
      .subscribe(value => {
        if (value && value.id) {
          this.router.navigate(['administration/cities/detail', value.id], { state: { byRedirect: true, nitCompany: this.nitCompany } });
        }
      })
  }

  updateConsecutive(type: 'Receipt' | 'Journal' | 'ReceiptFintech') {
    const control = {
      'Journal': this.incomeConsecutiveControl,
      'Receipt': this.expenseConsecutiveControl,
      'ReceiptFintech': this.receiptFintechConsecutiveControl
    }[type];
    if (!control.value) return this.snackBarService.openSnackBar('Debe ingresar un consecutivo válido', undefined, 'alert');
    this.spinner.show();
    this.companiesService.updateConsecutive(type, Number(control.value)).subscribe({
      next: (response) => {
        this.snackBarService.openSnackBar(response && response.message ? response.message : Fmt.string(ServiceMessages.FIELD_UPDATED_SUCCESSFULLY, 'el consecutivo'), undefined, 'success');
        this.getConsecutives();
      },
      error: (error) => {
        this.snackBarService.openSnackBar(Fmt.string(ServiceMessages.ERROR_UPDATING_DATA, 'el consecutivo'), undefined, 'error');
      },
      complete: () => {
        this.spinner.hide();
      }
    });
  }

  get isTeclogiUser(): boolean {
    return this.authService && this.authService.getCompany() && this.authService.getCompany().companyId === environment.rootNit;
  }

  get isPrincipalCompany(): boolean {
    return this.authService.getCompanySaaS() && this.authService.getCompanySaaS().companyId === this.nitCompany;
  }

  ngOnDestroy(): void {
    if (this.onboardingTourService.driverInstance) this.onboardingTourService.stopTour();
    if (this.citySub) this.citySub.unsubscribe();
  }

}



